export default __webpack_public_path__ + "static/media/george-floyd-protest.060976f6.png";